<template>
  <div class="tablelist">
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="parseInt(perPage)"
      no-data-label="No se encuentran datos para esta busqueda"
    >
      <template slot="caseZoho" slot-scope="props">
        {{listDataCase(props.rowData.Det_Zoho)}}
      </template>
      <template slot="status" slot-scope="props">
        <ul class="listUL">
            <li v-for="itemdata of JSON.parse(props.rowData.Det_Courses)" :key="itemdata.id">{{itemdata.CFPC_Name}}</li>
        </ul>
      </template>
    </va-data-table>
    <div class="text-right">
      <button class="loginbtn primaryBtn" type="submit" v-on:click="exportExcel">
          <va-icon name="fa fa-download" size="60" /> Generar Reporte
      </button>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import XLSX from 'xlsx'

export default {
  name: 'ReportCase',
  data () {
    return {
      term: null,
      perPage: '20',
      perPageOptions: ['5', '10', '20', '50', '100'],
      StatusOptions: [
        {
          id: 1,
          description: 'Activo',
        },
        {
          id: 2,
          description: 'Inactivo',
        },
      ],
      StatusOptionsModel: '',
      users: this.InfoView,
      ProgramsOptions: this.filterData.ListPrograms,
      ProgramsOptionsModel: '',
      ListFacultyOptions: this.filterData.ListFaculty,
      ListFacultyOptionsModel: '',
      arrayReport: [],
    }
  },
  props: {
    method: Function,
    InfoView: Array,
    HeadTable: Array,
    filterData: Array,
  },
  computed: {
    fields () {
      return this.HeadTable
    },
    filteredData () {
      if (((!this.term) || (this.term.length < 1)) && (!this.StatusOptionsModel.id) && (!this.ListFacultyOptionsModel) && (!this.ProgramsOptionsModel)) {
        return this.users
      }
      return this.users.filter(item => {
        if (this.term && this.term.length >= 1) {
          return item.Det_BannerID.toLowerCase().startsWith(this.term.toLowerCase())
        } else {
          return item
        }
      }).filter(item => {
        if (this.ListFacultyOptionsModel) {
          return item.Nam_Faculty.toLowerCase().startsWith(this.ListFacultyOptionsModel.toLowerCase())
        } else {
          return item
        }
      }).filter(item => {
        if (this.ProgramsOptionsModel) {
          return item.Nam_Program.toLowerCase().startsWith(this.ProgramsOptionsModel.toLowerCase())
        } else {
          return item
        }
      }).filter(item => {
        switch (this.StatusOptionsModel.id) {
          case 1:
            return item.staStatus === true
          case 2:
            return item.staStatus === false
          default:
            return item
        }
      })
    },
  },
  methods: {
    listDataCase: function (infData) {
      var refZohoOutput = JSON.parse(infData)
      return JSON.parse(refZohoOutput.details.output).dataCase[0].Case_Number
    },
    exportExcel: function () {
      if (this.filteredData.length >= 1) {
        this.arrayReport.length = 0
        let loader = this.$loading.show()
        this.arrayReport = this.filteredData

        var dateRef = new Date()
        var month = '' + (dateRef.getMonth() + 1)
        var day = '' + dateRef.getDate()
        if (month.length < 2) { month = '0' + month }
        if (day.length < 2) { day = '0' + day }
        const filename = 'CasosIbero_' + day + month + dateRef.getFullYear()

        let data = XLSX.utils.json_to_sheet(this.arrayReport)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
        loader.hide()
      }
    },
    dataReg (user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
}
</script>

<style>
.tablelist .va-button {
  color: #222 !important;
  border-color: #222 !important;
}

.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.tablelist .va-select__label {
  color: #222 !important;
}
.va-select__option--selected {
  color: #222 !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #222 !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #222 !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #222 !important;
}

.imgdata{
  cursor: pointer;
  margin-left: 2px !important;
  margin-right: 2px !important;
}
ul.listUL {
  width: 300px !important;
  list-style-type: square;
}
</style>
